const TerrainTypes = {
    FLAT: 'FLAT',
    MEDIUM_FLAT: 'MEDIUM_FLAT',
    MEDIUM_STEEP: 'MEDIUM_STEEP',
    STEEP: 'STEEP'
}

export default TerrainTypes;
